import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionConfidentialityDeedByInstitutionId: IInstitutionConfidentialityDeedLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadInstitutionConfidentialityDeedById: IInstitutionConfidentialityDeedLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionConfidentialityDeedLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionConfidentialityDeedLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionConfidentialityDeed: IInstitutionConfidentialityDeedSaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionConfidentialityDeedSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionConfidentialityDeedSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionConfidentialityDeed: IInstitutionConfidentialityDeedValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionConfidentialityDeedValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionConfidentialityDeedValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionConfidentialityDeed: IInstitutionConfidentialityDeedCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionConfidentialityDeedCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionConfidentialityDeedCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteInstitutionConfidentialityDeed: IInstitutionConfidentialityDeedDeleteActionCreator = (id) => {
    
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE,
            id
        }
    },
    DeleteSuccess: IInstitutionConfidentialityDeedDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS,
        }
    },
    DeleteFailure: IInstitutionConfidentialityDeedDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE,
            responseStatus
        }
    },

    SyncInstitutionConfidentialityDeed: IInstitutionConfidentialityDeedSyncActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC,
            institutionId
        }
    },
    SyncSuccess: IInstitutionConfidentialityDeedSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IInstitutionConfidentialityDeedSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionConfidentialityDeedClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionConfidentialityDeedFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS",
    ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR",

    ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER = "ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER";

export interface IInstitutionConfidentialityDeedLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionConfidentialityDeedLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionConfidentialityDeedLoadByInstitutionIdAction;
}

export interface IInstitutionConfidentialityDeedLoadSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_SUCCESS";
    formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionConfidentialityDeedLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed | Dtos.InstitutionConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionConfidentialityDeedLoadSuccessAction;
}

export interface IInstitutionConfidentialityDeedLoadFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionConfidentialityDeedLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedLoadFailureAction;
}

export interface IInstitutionConfidentialityDeedLoadByIdAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionConfidentialityDeedLoadByIdActionCreator {
    (id: number): IInstitutionConfidentialityDeedLoadByIdAction;
}

export interface IInstitutionConfidentialityDeedSaveAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE";
    formData: Dtos.InstitutionConfidentialityDeed;

}

export interface IInstitutionConfidentialityDeedSaveActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed
    ): IInstitutionConfidentialityDeedSaveAction;
}

export interface IInstitutionConfidentialityDeedSaveSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_SUCCESS";
    formData: Dtos.InstitutionConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionConfidentialityDeedSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionConfidentialityDeedSaveSuccessAction;
}

export interface IInstitutionConfidentialityDeedSaveFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedSaveFailureAction;
}

export interface IInstitutionConfidentialityDeedValidateAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE";
    formData: Dtos.InstitutionConfidentialityDeed;

}

export interface IInstitutionConfidentialityDeedValidateActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed
    ): IInstitutionConfidentialityDeedValidateAction;
}

export interface IInstitutionConfidentialityDeedValidateSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionConfidentialityDeed;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionConfidentialityDeedValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionConfidentialityDeedValidateSuccessAction;
}

export interface IInstitutionConfidentialityDeedValidateFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedValidateFailureAction;
}

export interface IInstitutionConfidentialityDeedCreateAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE",
    institutionId: number
}

export interface IInstitutionConfidentialityDeedCreateActionCreator {
    (institutionId: number): IInstitutionConfidentialityDeedCreateAction
}

export interface IInstitutionConfidentialityDeedCreateSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_SUCCESS";
    formData: Dtos.InstitutionConfidentialityDeed;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionConfidentialityDeedCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionConfidentialityDeedCreateSuccessAction;
}

export interface IInstitutionConfidentialityDeedCreateFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedCreateFailureAction;
}

export interface IInstitutionConfidentialityDeedDeleteAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE";
    id: number;
}

export interface IInstitutionConfidentialityDeedDeleteActionCreator {
    (id: number): IInstitutionConfidentialityDeedDeleteAction
}

export interface IInstitutionConfidentialityDeedDeleteSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_SUCCESS";
}

export interface IInstitutionConfidentialityDeedDeleteSuccessActionCreator {
    (): IInstitutionConfidentialityDeedDeleteSuccessAction;
}

export interface IInstitutionConfidentialityDeedDeleteFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedDeleteFailureAction;
}

export interface IInstitutionConfidentialityDeedClearAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionConfidentialityDeedClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionConfidentialityDeedClearAction;
}

export interface IInstitutionConfidentialityDeedFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionConfidentialityDeedFilterAction;
}

export interface IInstitutionConfidentialityDeedFilterAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_FILTER";
    formFilter: IFormFilter;
}

export interface IInstitutionConfidentialityDeedSyncAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC",
    institutionId: number
}

export interface IInstitutionConfidentialityDeedSyncActionCreator {
    (institutionId: number): IInstitutionConfidentialityDeedSyncAction
}

export interface IInstitutionConfidentialityDeedSyncSuccessAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_SUCCESS";
    formData: Dtos.InstitutionConfidentialityDeed[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedSyncSuccessActionCreator {
    (
        formData: Dtos.InstitutionConfidentialityDeed[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionConfidentialityDeedSyncSuccessAction;
}

export interface IInstitutionConfidentialityDeedSyncFailureAction {
    type: "ACTION_INSTITUTIONCONFIDENTIALITYDEED_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionConfidentialityDeedSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionConfidentialityDeedSyncFailureAction;
}

export type InstitutionConfidentialityDeedAction =
    IInstitutionConfidentialityDeedLoadByInstitutionIdAction |
    IInstitutionConfidentialityDeedLoadByIdAction |
    IInstitutionConfidentialityDeedLoadFailureAction |
    IInstitutionConfidentialityDeedLoadSuccessAction |
    IInstitutionConfidentialityDeedSaveAction |
    IInstitutionConfidentialityDeedSaveSuccessAction |
    IInstitutionConfidentialityDeedSaveFailureAction |
    IInstitutionConfidentialityDeedValidateAction |
    IInstitutionConfidentialityDeedValidateSuccessAction |
    IInstitutionConfidentialityDeedValidateFailureAction |
    IInstitutionConfidentialityDeedCreateAction |
    IInstitutionConfidentialityDeedCreateSuccessAction |
    IInstitutionConfidentialityDeedCreateFailureAction |
    IInstitutionConfidentialityDeedDeleteAction |
    IInstitutionConfidentialityDeedDeleteSuccessAction |
    IInstitutionConfidentialityDeedDeleteFailureAction |
    IInstitutionConfidentialityDeedSyncAction |
    IInstitutionConfidentialityDeedSyncSuccessAction |
    IInstitutionConfidentialityDeedSyncFailureAction |
    IInstitutionConfidentialityDeedClearAction | 
    IInstitutionConfidentialityDeedFilterAction;
